module.exports = __webpack_public_path__ + "img/plants-blue.f768835f.png";